import {doppeViewerLangIsRtl} from "../../client-server-common/doppe-viewer/doppe-viewer-lang";
import {useBymoPageProps} from "../../client-server-common";

export function useDoppViewerIsRtl () {
    return doppeViewerLangIsRtl(useBymoPageProps().lang);
}